import {
    UPDATE_SECTION,
    REMOVE_SECTION,
    SCROLL_TO_SECTION,
    UPDATE_TITLE_SECTION,
    REMOVE_TITLE_SECTION,
} from 'vue/vuex/mutation-types';

export function updateSection({ commit }, { section }) {
    commit(UPDATE_SECTION, { section });
}

export function removeSection({ commit }, { section }) {
    commit(REMOVE_SECTION, { section });
}

export function scrollToSection({ commit }, { anchor }) {
    commit(SCROLL_TO_SECTION, { anchor });
}

export function updateTitleSection({ commit }, { section }) {
    commit(UPDATE_TITLE_SECTION, { section });
}

export function removeTitleSection({ commit }, { section }) {
    commit(REMOVE_TITLE_SECTION, { section });
}



// WEBPACK FOOTER //
// ./sib-website/assets/src/js/app/vue/vuex/modules/section-nav/actions.js